<!-- No Selected Org -->
<ng-container *ngIf="!selectedOrg">
  <div>
    <yc-i18n
      key="nonprofits:textSearchOrgOfflineDescUpdate"
      defaultValue="Search for and select the organization requesting grant funds. If you are unable to find the organization, click 'Advanced search' for a more comprehensive search and helpful search tips.">
    </yc-i18n>
  </div>
  <div>
    <!-- Nonprofit Autocomplete -->
    <div class="pt-2 pb-2 flex-grow-1">
      <gc-search-npo-autocomplete
        [clientId]="program.clientId"
        [programId]="program.id"
        [allowedOrgLocations]="program.allowedOrgLocations"
        [charityBucketId]="program.charityBucketId || ''"
        [placeholder]="'GLOBAL.searchForYourOrganization' | ycI18n: 'Search for your organization'"
        [processorIsYourCause]="processorIsYourCause"
        (onOrgSelect)="onOrgSelect($event)">
      </gc-search-npo-autocomplete>
      <!-- Advanced Search -->
      <yc-button class="d-flex justify-content-end"
        [link]="true"
        [langKey]="'common:textAdvancedSearch'"
        [defaultText]="'Advanced search'"
        (onClick)="showSelectOrgModal()">
      </yc-button>
    </div>
  </div>
</ng-container>

<!-- Selected Org -->
<div *ngIf="selectedOrg"
  class="mt-2 mb-5">
  <yc-alert *ngIf="preventOrgChange"
    alertClass="info"
    [message]="preventOrgChangeMessage">
  </yc-alert>

  <!-- Vetting -->
  <ng-container *ngIf="showContactForm">
    {{ confirmationText }}
  </ng-container>
  <!-- Nonprofit Block -->
  <div [class.mt-3]="showContactForm">
    <yc-nonprofit-block-display
      [name]="selectedOrg.document.remittanceName ||
        selectedOrg.document.displayName ||
        selectedOrg.document.name"
      [parentName]="selectedOrg.document.parentName"
      [parentRouterLink]="selectedOrg.document.parentGuid ?
        '/management/nonprofit/' + selectedOrg.document.parentGuid + '/profile' : 
        ''"
      [nameIsLink]="!!(selectedOrg.document.nonprofitGuid || selectedOrg.document.id)"
      [openNameInNewTab]="true"
      [nameRouterLink]="'/management/nonprofit/' +
        (selectedOrg.document.nonprofitGuid || selectedOrg.document.id) +
        '/profile'"
      [npoId]="selectedOrg.document.id"
      [addressString]="selectedOrg.document.addressString"
      [ein]="selectedOrg.document.registrationId"
      [isPrivateOrg]="selectedOrg.document.isPrivateOrg"
      [img]="{
        iconURL: selectedOrg.document?.iconURL,
        classification: selectedOrg.document?.classification
      } | getOrgIcon"
      [showClear]="!preventOrgChange"
      (onClear)="onOrgSelect(null)">
    </yc-nonprofit-block-display>
  </div>

  <div *ngIf="showContactForm"
    class="d-flex mb-4 mt-3"
    [formGroup]="nonprofitContactGroup">
    <!-- Contact Full Name -->
    <div class="add-org-input">
      <yc-input
        (onChange)="setContactName($event)"
        [label]="'common:labelOrganizationContactFullName' | ycI18n:'Organization contact full name'"
        name="contactFullName">
      </yc-input>
    </div>
    <!-- Contact Email -->
    <div class="add-org-input">
      <yc-input
        (onChange)="setContactEmail($event)"
        [label]="'common:labelOrgContactEmail' | ycI18n:'Organization contact email'"
        name="contactEmail">
      </yc-input>
    </div>

    <!-- Contact Website -->
    <div class="add-org-input-right">
      <yc-input
        (onChange)="setContactWebsite($event)"
        [label]="'common:labelOrgContactWebsite' | ycI18n:'Organization website'"
        name="contactWebsite">
      </yc-input>
    </div>
  </div>
</div>
